import Swiper from 'swiper';
import { playPauseVideo } from '../helpers/video';

export const imageSlider = () => {
	let imageSliderModules = document.querySelectorAll('.m__islider');

	if (imageSliderModules) {
		imageSliderModules.forEach((imageSliderModule) => {
			let slides = imageSliderModule.querySelectorAll('.m__islider__slide');

			// Check if the first slide contains a video and if so play the video
			const initSlide = slides[0];
			const initSlideVideo = initSlide.querySelector('.js__islider-video'); 
	
			if ( initSlideVideo ) {
				initSlideVideo.play();
			}
	
			// Loop through each slide and initialise the playPuase functionality
			slides.forEach(slide => {
				const video = slide.querySelector('.js__islider-video');
				const videoControls = slide.querySelector('.js-video-controls');
		
				if ( video && videoControls ) {
					playPauseVideo(video, videoControls);
				}
			});

			if (slides.length > 1) {

				// Initialise the slider
				const iSwiper = new Swiper(imageSliderModule.querySelector('.m__islider__swiper-wrapper .swiper'), {
					slidesPerView: 1,
					shortSwipes: false,
					slideToClickedSlide: false,
					keyboard: {
						enabled: true,
						onlyInViewport: true,
					},
				});

				let isliderNextArrow = imageSliderModule.querySelector('.js__islider__swiper-next');
				let isliderPrevArrow = imageSliderModule.querySelector('.js__islider__swiper-prev');

				// Updates when a slide changes
				iSwiper.on('slideChange', function () {
					// If the previous slide contains a video then pause the video
					const prevSlideVideo = iSwiper.slides[iSwiper.previousIndex].querySelector('.js__islider-video');

					if ( prevSlideVideo ) {
						prevSlideVideo.pause();
					}
	
					// Check if the current slide contains a video
					const currentSlide = iSwiper.slides[iSwiper.activeIndex];
					const currentSlideVideo = currentSlide.querySelector('.js__islider-video');
					const currentSlideVideoControls = currentSlide.querySelector('.js-video-controls');
	
					if ( currentSlideVideo && currentSlideVideoControls ) {
						// If the play icon is hidden this means that the video hasn't been paused before changing slides so play the video
						const playIcon = currentSlideVideoControls.querySelector('.e__video-controls-image--play');
	
						if ( playIcon && playIcon.classList.contains('hidden') ) {
							currentSlideVideo.play();
						}
					}
				});

				// Move to next slide if 'prev' arrow clicked
				if (isliderPrevArrow) {
					isliderPrevArrow.addEventListener('click', (event) => {
						let prevSlide = iSwiper.activeIndex - 1;
						if (prevSlide < 0) {
							prevSlide = iSwiper.slides.length; // Set to the last slide
						}
						iSwiper.slideTo(prevSlide);
					})
				}

				// Move to next slide if 'next' arrow clicked
				if (isliderNextArrow) {
					isliderNextArrow.addEventListener('click', (event) => {
						let nextSlide = iSwiper.activeIndex + 1;
						if (nextSlide >= iSwiper.slides.length) {
							nextSlide = 0; // Return to start!
						}
						iSwiper.slideTo(nextSlide);
					})
				}
			}
		})
	}
}
